/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonDailyDelegationInfo } from './BabylonDailyDelegationInfo';

export type BabylonHomeBtcStakingInfo = {
    TRXHTP: BabylonHomeBtcStakingInfo.TRXHTP;
    STKTP: BabylonHomeBtcStakingInfo.STKTP;
    DAVGDLGAMT: string;
    DAVGDLGVAL: string;
    DDLGLIST: Array<BabylonDailyDelegationInfo>;
};

export namespace BabylonHomeBtcStakingInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }

    export enum STKTP {
        BTC_STAKING = 'BTC_STAKING',
    }


}

